// import { Button } from 'primereact/button';
// import { ColumnDataType } from 'primereact/column';
// import { confirmDialog } from 'primereact/confirmdialog';
// import { TieredMenu } from 'primereact/tieredmenu';
// import { MutableRefObject, useRef, MouseEvent } from 'react';
import moment from 'moment';
import { getAccountRolesInRussian } from 'utils/functions';

// WARNING: don't do in MVP version

// export const ActionBodyTemplate = (rowData: ColumnDataType) => {
//   const menuItems = [
//     {
//       label: 'Восстановить пароль',
//       command: () =>
//         confirmDialog({
//           message: 'Are you sure you want to proceed?',
//           header: 'Confirmation',
//           icon: 'pi pi-exclamation-triangle',
//           accept: () => console.log('123'),
//           reject: () => console.log('123'),
//         }),
//     },
//     {
//       label: 'Назначить роль',
//       items: [
//         {
//           label: 'Администратор',
//         },
//         {
//           label: 'Модератор',
//         },
//       ],
//     },
//   ];

//   const menu = useRef<TieredMenu>(null);
//   const handleClickButton = (event: MouseEvent) => {
//     console.log(rowData);
//     (menu as MutableRefObject<TieredMenu>).current.toggle(event);
//   };

//   return (
//     <>
//       <Button
//         type="button"
//         icon="pi pi-cog"
//         onClick={handleClickButton}
//       />
//       <TieredMenu
//         model={menuItems}
//         popup
//         ref={menu}
//       />
//     </>
//   );
// };

export const RoleBodyTemplate = ({ roles }: { roles: string[] }) => (
  <div>{getAccountRolesInRussian(roles).join(', ')}</div>
);

export const IsDeletedBodyTemplate = ({
  isDeleted,
}: {
  isDeleted: boolean;
}) => <div>{isDeleted ? 'Помечен на удаление' : 'Активен'}</div>;

export const SurnameBodyTemplate = ({ lastName }: { lastName: string }) => (
  <div>{lastName || '-'}</div>
);

export const NameBodyTemplate = ({ firstName }: { firstName: string }) => (
  <div>{firstName || '-'}</div>
);

export const CreatedAtBodyTemplate = ({ createdAt }: { createdAt: number }) => (
  <div>{moment(createdAt).format('DD.MM.YYYY HH:mm')}</div>
);

export const ModifiedAtBodyTemplate = ({
  modifiedAt,
}: {
  modifiedAt: number | null;
}) => (
  <div>{modifiedAt ? moment(modifiedAt).format('DD.MM.YYYY HH:mm') : '-'}</div>
);

export const LastActivityTimeBodyTemplate = ({
  lastActivityTime,
}: {
  lastActivityTime: number;
}) => <div>{moment(lastActivityTime).format('DD.MM.YYYY HH:mm')}</div>;

export const IsEmailConfirmedBodyTemplate = ({
  isEmailConfirmed,
}: {
  isEmailConfirmed: boolean;
}) => <div>{isEmailConfirmed ? 'Да' : 'Нет'}</div>;

export const EmiasLinkedBodyTemplate = ({
  emiasLinked,
}: {
  emiasLinked: boolean;
}) => <div>{emiasLinked ? 'Да' : 'Нет'}</div>;

export const LastMeasurementSyncDateBodyTemplate = ({
  lastMeasurementSyncDate,
}: {
  lastMeasurementSyncDate: number | null;
}) => (
  <div>
    {lastMeasurementSyncDate
      ? moment(lastMeasurementSyncDate).format('DD.MM.YYYY HH:mm')
      : '-'}
  </div>
);

export const EmailBodyTemplate = ({ email }: { email: string }) => (
  <div
    title={email}
    style={{
      width: '300px',
      wordBreak: 'break-all',
    }}
  >
    {email}
  </div>
);
